import React from "react";
import Select from "react-select";
import { DatePicker } from "rsuite";

import PageTitle from "../../layouts/PageTitle";

const options = [
  { value: "1", label: "Subject" },
  { value: "2", label: "Politics" },
  { value: "3", label: "Designing" },
  { value: "4", label: "Computer" },
];

const options2 = [
  { value: "1", label: "Department" },
  { value: "2", label: "Computer" },
  { value: "3", label: "Data Entry" },
  { value: "4", label: "Management" },
];

const options3 = [
  { value: "1", label: "Asset type" },
  { value: "2", label: "Book" },
  { value: "3", label: "Newspaper" },
  { value: "4", label: "Comics" },
];

const options4 = [
  { value: "1", label: "Status" },
  { value: "2", label: "In Stock" },
  { value: "3", label: "Out of Stock" },
];

const AddPermissions = () => {
  return (
    <>
      <PageTitle activeMenu={"Add Permissions"} motherMenu={"Permissions"} />
      <div className="row">
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Add Permissions</h4>
            </div>
            <div className="card-body">
              <form>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="form-group">
                      <label className="form-label">Type</label>
                      <Select
                        isSearchable={false}
                        options={[
                          {
                            value: "technical_author",
                            label: "Technical Author",
                          },
                          { value: "team_leader", label: "Team Leader" },
                          { value: "guest", label: "Guest" },
                        ]}
                        placeholder="Select Type"
                        className="custom-react-select"
                      />
                    </div>
                  </div>
                  <div className="col-sm-12">
                    <div className="form-group">
                      <label className="form-label" htmlFor="tournamentName">
                        Name
                      </label>
                      <input
                        id="permissionName"
                        placeholder="Enter Permission Name"
                        type="text"
                        className="form-control"
                        required
                      />
                    </div>
                  </div>
                </div>
                <div className="col-lg-12 col-md-12 col-sm-12">
                  <button type="submit" className="btn btn-primary me-1">
                    Submit
                  </button>
                  <button type="submit" className="btn btn-danger light">
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddPermissions;
